import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Insured from '@/views/private/configuration/insured/insured.vue'

import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'
import PersonRepository from '@/shared/http/repositories/configuration/person'

import PersonForms from './form/person-form'
import PersonModel from './model/personmodel'

import _ from 'underscore'

export default {
  name: 'Person',
  mixins: [ActionsForm],
  data () {
    return {
      data: PersonModel,
      form: PersonForms,
      listNames: [],
      nameSearch: '',
      selecteName: null,
      showModal: false
    }
  },
  components: {
    Insured
  },
  watch: {
    nameSearch: _.debounce(function (data) {
      this.onSearch(data)
    }, 500),
    selecteName: function (data) {
      this.onEdit(data.value)
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllState()
      // --> Set manual
      if (this.$refs.personTypeahead) {
        this.$refs.personTypeahead.inputValue = ''
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      // --> Set manual
      if (this.$refs.personTypeahead) {
        this.$refs.personTypeahead.inputValue = ''
      }
      this.nameSearch = ''
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 500)
    },
    setState (stateID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.stateID.value = stateID
          resolve()
        }, 200)
      })
    },
    changeState (stateID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.cityID.options = []
          loading.push()
          CityRepository.GetAllByStateID(stateID)
            .then((response) => {
              self.form.cityID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 800)
      })
    },
    setCity (cityID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.cityID.value = cityID
          resolve()
        }, 500)
      })
    },
    onEdit (obj) {
      var self = this
      self.form.name.value = obj.name
      self.form.cpfCnpj.value = obj.cpfCnpj
      self.form.rg.value = obj.rg
      self.form.cnh.value = obj.cnh
      self.form.address.value = obj.address
      self.form.addressNumber.value = obj.addressNumber
      self.form.complement.value = obj.complement
      self.form.district.value = obj.district
      self.form.zipcode.value = obj.zipcode
      self.form.phoneNumber.value = obj.phoneNumber
      self.form.cellNumber.value = obj.cellNumber
      self.form.email.value = obj.email

      // --> Set manual
      if (this.$refs.personTypeahead) {
        if (obj.name !== null) {
          this.$refs.personTypeahead.inputValue = obj.name
        }
      }

      if (obj.state !== null && obj.cityID !== '00000000-0000-0000-0000-000000000000' && obj.cityID !== null) {
        // DADOS ESTADO/CIDADE
        // --> Set manual
        self.setState(obj.state.id)
          .then(func => self.changeState(obj.state.id, func))
          .then(func => self.setCity(obj.cityID, func))
          .catch(function (err) {
            console.log(err)
          })
      }

      self.$emit('Edit', obj)
    },
    onEditById (ID) {
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        PersonRepository.GetById(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.onClear()
        this.$emit('Edit', null)
      }
    },
    onSearch (query) {
      loading.push()
      if (query) {
        PersonRepository.GetAllByName(query)
          .then((response) => {
            this.listNames = this.onResultAutoComplete(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.onClear()
        this.$emit('Edit', null)
        loading.pop()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/person/person.js